const STORAGE_KEY = 'bt.kiosk.deviceToken';

export function getKioskDeviceToken(): string | undefined {
  return localStorage.getItem(STORAGE_KEY) ?? undefined;
}

/**
 * Throws if the browser refuses the write (private mode, quota exhausted,
 * storage disabled). Callers must handle it: at that point a server-side kiosk
 * session already exists, so the failure is not "binding failed" (see
 * `KioskSetupPage`, security review L2).
 */
export function setKioskDeviceToken(token: string): void {
  localStorage.setItem(STORAGE_KEY, token);
}

export function clearKioskDeviceToken(): void {
  localStorage.removeItem(STORAGE_KEY);
}
